/**
 * Fills in empty product descriptions and injects product badges
 * (including Sold Out) into Globo Smart Filter product cards.
 */
(function () {
  'use strict';

  const descCache = {};

  /* ── Descriptions ─────────────────────────────────────────── */

  const fillDescriptions = () => {
    const cards = document.querySelectorAll('.spf-has-filter .product-card-grid__description:empty');
    cards.forEach((el) => {
      const link = el.closest('.product-card-grid')?.querySelector('a[href*="/products/"]');
      if (!link) return;
      const match = link.getAttribute('href').match(/\/products\/([^?#/]+)/);
      if (!match) return;
      const handle = match[1];

      if (el.dataset.filled) return;
      el.dataset.filled = 'true';

      if (descCache[handle]) {
        descCache[handle].then((desc) => { if (desc) el.textContent = desc; });
        return;
      }

      descCache[handle] = fetch(`/products/${handle}.json`)
        .then((r) => r.json())
        .then((data) => {
          const html = data.product.body_html || '';
          const tmp = document.createElement('div');
          tmp.innerHTML = html;
          let text = (tmp.textContent || tmp.innerText || '').trim();
          if (text.length > 300) text = text.substring(0, 300) + '...';
          return text;
        })
        .catch(() => '');

      descCache[handle].then((desc) => { if (desc) el.textContent = desc; });
    });
  };

  /* ── Badges ───────────────────────────────────────────────── */

  const getBadgeData = () => {
    const el = document.getElementById('globo-product-badges-data');
    if (!el) return {};
    try { return JSON.parse(el.textContent) || {}; }
    catch { return {}; }
  };

  const escAttr = (str) =>
    String(str || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');

  const buildBadge = (text, color) =>
    `<div class="product-badge product-card-grid__badge" style="background-color: ${escAttr(color)};"><span class="product-badge__text">${escAttr(text)}</span></div>`;

  const buildSoldOutBadge = () =>
    '<div class="product-badge product-badge--sold-out product-card-grid__badge"><span class="product-badge__text">Sold Out</span></div>';

  const getHandle = (card) => {
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    const match = link.getAttribute('href').match(/\/products\/([^?#/]+)/);
    return match ? match[1] : null;
  };

  const fillBadges = () => {
    const data = getBadgeData();
    const cards = document.querySelectorAll('.spf-has-filter .product-card-grid');

    for (const card of cards) {
      const overlayLeft = card.querySelector('.product-card-grid__overlay-left');
      if (!overlayLeft || overlayLeft.dataset.badgesFilled) continue;
      overlayLeft.dataset.badgesFilled = 'true';

      const handle = getHandle(card);
      if (!handle || !data[handle]) continue;

      const { available, badges } = data[handle];
      let html = '';

      if (!available) {
        html += buildSoldOutBadge();
      }

      if (badges?.length) {
        for (const badge of badges) {
          html += buildBadge(badge.text, badge.color);
        }
      }

      if (html) {
        overlayLeft.innerHTML = html;
      }
    }
  };

  /* ── Hover class ─────────────────────────────────────────── */

  const fillHoverClass = () => {
    const cards = document.querySelectorAll('.spf-has-filter .product-card-grid:not(.product-card-grid--has-hover)');
    for (const card of cards) {
      if (card.querySelector('.product-card-grid__image--secondary')) {
        card.classList.add('product-card-grid--has-hover');
      }
    }
  };

  /* ── Observer & Init ──────────────────────────────────────── */

  const runAll = () => {
    fillDescriptions();
    fillBadges();
    fillHoverClass();
  };

  const observe = () => {
    const target =
      document.getElementById('ProductGridContainer') ||
      document.querySelector('.gf-products-wrapper') ||
      document.querySelector('.collection');
    if (!target) return;

    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.addedNodes.length) {
          setTimeout(runAll, 300);
          return;
        }
      }
    }).observe(target, { childList: true, subtree: true });
  };

  const init = () => {
    runAll();
    observe();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('globo:filter:done', () => setTimeout(runAll, 300));
  document.addEventListener('globo:search:done', () => setTimeout(runAll, 300));
})();
